import {configureStore} from "@reduxjs/toolkit";
import sktrDetailsSlice from "./sktrSlice";
// import { needsAttentionSlice } from "./sktrSlice";




// // console.log(needsAttention);
// // console.log(availabilty);

// // <----- Slices of Store ----->

// // Needs Attention Slice
// const needsAttentionActions = createSlice({
//     name : 'alerts',
//     initialState : initialState,
//     reducer : {
//         sktrClick(state) {
//             // open skutr which is clicked
//         }
//     }
// });



//<----- Store ------>

// Create a store

const store = configureStore({
    reducer : {
        sktr : sktrDetailsSlice.reducer,
        // needsAttention : needsAttentionSlice.reducer,
    },
})


// Export Store
export default store;
